import { useCallback, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { CUSTOMER_AMENDMENTS_PER_PAGE, fetchCustomerAmendments } from '../services/customers';
import { customerKeys } from './customerKeys';

/** Page state is keyed by customer id, so another holder's log starts on page 1. */
export function useCustomerAmendments(id: string | undefined, enabled: boolean) {
    const [pageState, setPageState] = useState({ id, page: 1 });
    const page = pageState.id === id ? pageState.page : 1;
    const setPage = useCallback((next: number) => setPageState({ id, page: next }), [id]);

    const query = useQuery({
        queryKey: customerKeys.amendmentsPage(id ?? '', page, CUSTOMER_AMENDMENTS_PER_PAGE),
        queryFn: () => fetchCustomerAmendments(id!, { page, perPage: CUSTOMER_AMENDMENTS_PER_PAGE }),
        enabled: enabled && !!id,
        // Keeps the previous page on screen while the next loads, but never
        // another customer's rows.
        placeholderData: (previousData, previousQuery) =>
            previousQuery?.queryKey[1] === (id ?? '') ? previousData : undefined,
    });

    return { query, page, setPage };
}
